/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDividerRows = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v20H2V2zm-9 14v2h-2v-2zm4 0v2h-2v-2zM4 20h16v-2h-1v-2h1v-3h-1v-2h1V8h-1V6h1V4H4v2h1v2H4v3h1v2H4v3h1v2H4zm5-4v2H7v-2zm4-5v2h-2v-2zm4 0v2h-2v-2zm-8 0v2H7v-2zm4-5v2h-2V6zm4 0v2h-2V6zM9 6v2H7V6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDividerRows as DividerRows };
